import React from 'react';
import { NodeProps } from 'reactflow';
import useCollapseController from '@components/MainStage/hooks/useCollapseController';
import { CollapseIcon } from '@components/MainStage/MainStage.styled';
import { LayerTypes } from '@constants/canvas/layers';
import useCanvasWidth from '@hooks/canvas/useCanvasWidth';
import { Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { SubLayerIcon } from '@utils/iconsDefs';

import useCollapsedLayers from '../collapsedLayers.store';

import { SubLayerName, SubLayerNodeStyled } from './SubLayerNode.styled';

export type NodeData = {
  label: string;
  withBottomBorder?: boolean;
};

export function SubLayerNode({ id, data }: NodeProps<NodeData>) {
  const { zoomedCanvasWidth } = useCanvasWidth();

  const { isCollapsed } = useCollapsedLayers();
  const collapsed = isCollapsed(id as LayerTypes);

  const { handleToggleLayer } = useCollapseController();

  return (
    <SubLayerNodeStyled
      $withBottomBorder={!!data.withBottomBorder}
      id={id}
      $canvasWidth={zoomedCanvasWidth}
    >
      <SubLayerName
        onClick={(e) => {
          e.stopPropagation();
          handleToggleLayer(id as LayerTypes);
        }}
      >
        <SubLayerIcon fill={themePalette.grey[collapsed ? 700 : 800]} />

        <Typography
          variant="body1"
          color={collapsed ? 'grey.700' : 'grey.900'}
          sx={{ ml: '10px' }}
        >
          {data.label}
        </Typography>

        <CollapseIcon collapsed={collapsed} />
      </SubLayerName>
    </SubLayerNodeStyled>
  );
}
